module.exports = __webpack_public_path__ + "static/media/ECMAScript 2049.624660d3.png";